import { BROOF_HOST } from "./const";

window.dataLayer = window.dataLayer || [];

export default function() { 
    if (process.env.REACT_APP_ENV === 'prod' && window.location.origin.includes(BROOF_HOST)) {
        window.dataLayer.push(arguments); 
    }
}